import { BankingValueObjectsCardTypeEnum } from 'generated/resources/graphql'

export const isSingleUse = (card: { type: BankingValueObjectsCardTypeEnum }): boolean => {
  return card.type === 'single_use'
}
